import axios, { AxiosResponse } from 'axios';
import type { AxfoodCartViewModel } from '@occ/api-client';

const setPaymentMode = (mode: PaymentType): Promise<AxiosResponse<AxfoodCartViewModel>> => {
  const API_URL = '/axfood/rest/checkout/paymentmode';
  return axios.post(API_URL, { mode });
};

export default setPaymentMode;
